export default __webpack_public_path__ + "static/media/36I-114292_-21037_0.51725dca.jpg";